<template>
  <div id="dmvLocsDashboard"></div>
</template>

<script>
/* global L */
/*eslint no-inner-declarations: */
import { useRootStore } from "../store";
import { toRaw } from "vue";
import { fetchWaitTimeAndCapacity, waitTimeRange } from "../actions/waitTimeActions";
export default {
  name: "MapComponent",
  computed: {
    getIsStateHoliday(){
      return this.rootStore.isStateHoliday;
    },

    // Is the page in the special "show only kiosks" mode
    getShowOnlyKiosk(){
      return this.rootStore.showOnlyKiosk;
    },

    // DL Locations with Kiosks included
    getOfficekDLwithKiosks(){
        return this.rootStore.officekDLwithKiosks;
    },

    // DL only, no kiosks
    getOfficeDL() {
        return this.rootStore.officeDL;
    },

    // Saturday only DL offices
    getOfficeDLSaturday(){
       return this.rootStore.officeDLSaturday;
    },

    // LPA Locations with Kiosks included
    getOfficeLPAwithKiosks(){
        return this.rootStore.officeLPAwithKiosks;
    },

    // LPA only, no kiosks
    getOfficeLPA() {
        return this.rootStore.officeLPA;
    },

    // All kiosk locations
    getOfficeKAllKiosks(){
      return this.rootStore.officeKAllKiosks;
    },

    // ONly LPA Kiosk locations
    getOfficeKAllKiosksLPA(){
      return this.rootStore.officeKAllKiosksLPA;
    },

    // IRP offices
    getOfficeIRP() {
        return this.rootStore.officeIRP;
    },

    // License and theft offices
    getOfficeLT() {
        return this.rootStore.officeLT;
    },


    getClosedOfficeDL() {
        return this.rootStore.closedOfficeDL;
    },
    getClosedOfficeLPA() {
        return this.rootStore.closedOfficeLPA;
    },
    getClosedOfficeLT() {
        return this.rootStore.closedOfficeLT;
    },
    getClosedOfficeIRP() {
        return this.rootStore.closedOfficeIRP;
    },
    getClosedOfficeKioskDLVR() {
        return this.rootStore.closedOfficeKioskDLVR;
    }, 
 


    getMapAPIkey() {
      return this.rootStore.mapAPIkey;
    },
    getUserLocation() {
      return this.rootStore.userLocation;
    },
    getZoomedLocation() {
      return this.rootStore.zoomedLocation;
    },
    getDataLoaded() {
      return this.rootStore.dataLoaded;
    },
    getToggleDL() {
      return this.rootStore.toggleDL;
    },
    getToggleLPA() {
      return this.rootStore.toggleLPA;
    },
    getToggleMO() {
      return this.rootStore.toggleMO;
    },
    getToggleLT() {
      return this.rootStore.toggleLT;
    },
    getToggleIRP() {
      return this.rootStore.toggleIRP;
    },
    getToggleClosed() {
      return this.rootStore.toggleClosed;
    },
    getToggleDLSaturday() {
      return this.rootStore.toggleDLSaturday;
    },

    getToggleDLkiosk(){
      return this.rootStore.toggleKioskDL;
    },

    getToggleLPAkiosk(){
      return this.rootStore.toggleKioskVR;
    },

    getPrimaryCard: function () {
      return this.rootStore.primaryCard;
    },
    getIWTLoadWindow() {
      return this.rootStore.iwtLoadWindow;
    },
    getClosedOfficeMode() {
      return this.rootStore.mapMode;
    }
  },
  data: function () {
    return {
      rootStore: useRootStore(),
      // districtLayerFeatures: [],
      kioskMode:false,
      satrudayMode:false,
      iconUrlSize: [30, 30],
      setView: [35.24927, -79.99741],
      AVMoptions: {
        bingMapsKey:
          "AhZV-7p6O0GkB7SWeEMYX3AGi9jxHMOaI7H9aqlymzHRWRomi3YMKxf3G4jzmnCp",
        imagerySet: "RoadOnDemand",
        style:
          "&st=wt|fc:ffffff_me|lbc:CCCCCC;loc:ffffff_cah|lbc:CCCCCC;fc:CCCCCC;sc:CCCCCC_tr|lbc:CCCCCC;fc:CCCCCC;sc:CCCCCC_nh|v:0;lv:0_pl|v:0;lv:0_vg|v:0;lv:0_ad|v:0;lv:0",
      },

      markerIconDLOkioskopen: L.icon({
        iconUrl: "./assets/pin_dl_open_kiosk.svg",
        iconSize: [30, 30],
      }),

      markerIconDLSaturdayopen: L.icon({
        iconUrl: "./assets/pin_dl_open.svg",
        iconSize: [30, 30],
      }),
      markerIconDLOopen: L.icon({
        iconUrl: "./assets/pin_dl_open.svg",
        iconSize: [30, 30],
      }),

      // Shows a little yellow dot when the wait is 1+ hours
      markerIconDLOopenYellow: L.icon({
        iconUrl: "./assets/pin_dl_open_yellow_dot_triangle.svg",
        iconSize: [30, 30],
      }),

      // Shows a little red dot when the wait is 2+ hours
      markerIconDLOopenRed: L.icon({
        iconUrl: "./assets/pin_dl_open_red_dot_stripe.svg",
        iconSize: [30, 30],
      }),

      markerIconDLClosed: L.icon({
        iconUrl: "./assets/pin_dl_closed.svg",
        iconSize: [30, 30],
      }),

      // DL office closed with kiosk
      markerIconDLClosedKiosk: L.icon({
        iconUrl: "./assets/pin_dl_closed_kiosk.svg",
        iconSize: [30, 30],
      }),


      // LPA office with kiosks
      markerIconLPAOkioskopen: L.icon({
        iconUrl: "./assets/pin_lpa_open_kiosk.svg",
        iconSize: [30, 30],
      }),

      markerIconLPAOpen: L.icon({
        iconUrl: "./assets/pin_lpa_open.svg",
        iconSize: [30, 30],
      }),
      markerIconLPAClosed: L.icon({
        iconUrl: "./assets/pin_lpa_closed.svg",
        iconSize: [30, 30],
      }),
      markerIconIRPOpen: L.icon({
        iconUrl: "./assets/pin_irp_open.svg",
        iconSize: [30, 30],
      }),
      markerIconIRPClosed: L.icon({
        iconUrl: "./assets/pin_irp_closed.svg",
        iconSize: [30, 30],
      }),
      markerIconLTOpen: L.icon({
        iconUrl: "./assets/pin_lt_open.svg",
        iconSize: [30, 30],
      }),
      markerIconLTClosed: L.icon({
        iconUrl: "./assets/pin_lt_closed.svg",
        iconSize: [30, 30],
      }),

      layerClosedLTOffice: new L.layerGroup(),
      layerClosedIRPOffice: new L.layerGroup(),
      layerClosedLPAOffice: new L.layerGroup(),
      layerClosedDLOffice: new L.layerGroup(),
      layerClosedKioskDLOffices: new L.layerGroup(),
      // layerClosedMOOffice: new L.layerGroup(),

      layerOpenIRPOffice: new L.layerGroup(),
      layerOpenLTOffice: new L.layerGroup(),
      // layerOpenMOOffice: new L.layerGroup(),
     
      layerOpenKioskDLOffices: new L.layerGroup(),
      layerOpenKioskLPAOffices: new L.layerGroup(),

      layerOpenLPAOffice: new L.layerGroup(),
      layerOpenLPAOfficeWithKiosks: new L.layerGroup(),
      
      layerOpenDLOffice: new L.layerGroup(),
      layerOpenDLOfficeWithKiosks: new L.layerGroup(),
      layerOpenDLSaturdayOffice: new L.layerGroup(),
      layerOpenDLSaturdayOfficeWithKiosks: new L.layerGroup(),

      dmvMap: "",
    };
  },
  created() {
    
    
  },
  methods: {
    waitTimeRange,
    // Sets selected marker
    makeCardPrimary(marker) {
      this.primaryCard = marker;
    },
    clearPins() {
      this.layerClosedLTOffice.clearLayers();
      this.layerClosedIRPOffice.clearLayers();
      this.layerClosedLPAOffice.clearLayers();
      this.layerClosedDLOffice.clearLayers();
      // this.layerClosedMOOffice.clearLayers();

      this.layerOpenIRPOffice.clearLayers();
      this.layerOpenLTOffice.clearLayers();
      // this.layerOpenMOOffice.clearLayers();
      this.layerOpenLPAOffice.clearLayers();
      this.layerOpenDLOfficeSaturday.clearLayers();
      this.layerOpenDLOffice.clearLayers();
    },
    
    removeLayerFromMap(currentLayer) {
      if(this.dmvMap.hasLayer(this[currentLayer])) {
        this.dmvMap.removeLayer(this[currentLayer]);
      }
    },
  

      // When computed offices are loaded/update, loads map
    async loadPins() {
     
      this.showClosedMarkers(this.getToggleClosed);
      // Pins for open DL offices, including kiosks. This is defaulted to "on" on page load.
      this.getOfficekDLwithKiosks.forEach((_loc) => {

        // Add a way to show a yellow icon for busy offices and a red icon for very busy offices, or for kiosk locations
        let DLofficeMarker = this.markerIconDLOopen

        // Handle IWT times
        if(this.getIWTLoadWindow !== undefined && this.getIWTLoadWindow === true && _loc.IWTwaitLevel === "yellow"){
          DLofficeMarker = this.markerIconDLOopenYellow
        } else if(this.getIWTLoadWindow !== undefined && this.getIWTLoadWindow === true && _loc.IWTwaitLevel === "red"){
          DLofficeMarker = this.markerIconDLOopenRed
        } else{
          DLofficeMarker = this.markerIconDLOopen
        }


        // Add a way to show Kiosk locations with a different icon
        if(_loc.officeTypes.includes("kiosk") === true){
          DLofficeMarker = this.markerIconDLOkioskopen
        }

        this.renderDMVLocs(
          _loc,
          "license",
          this.layerOpenDLOfficeWithKiosks,
          DLofficeMarker 
        );
      });


      // Pins for DL offices with no kiosks shown. Hidden on page load.
      this.getOfficeDL.forEach((_loc) => {

        // Add a way to show a yellow icon for busy  offices and a red icon for very busy offices
        let IWTMarker = this.markerIconDLOopen

        if(this.getIWTLoadWindow !== undefined && this.getIWTLoadWindow === true && _loc.IWTwaitLevel === "yellow"){
          IWTMarker = this.markerIconDLOopenYellow
        } else if(this.getIWTLoadWindow !== undefined && this.getIWTLoadWindow === true && _loc.IWTwaitLevel === "red"){
          IWTMarker = this.markerIconDLOopenRed
        } else{
          IWTMarker = this.markerIconDLOopen
        }

        this.renderDMVLocs(
          _loc,
          "license",
          this.layerOpenDLOffice,
          IWTMarker 
        );
      });

      // Pins for Saturday Open offices. This layer is hidden on load
      this.getOfficeDLSaturday.forEach((_loc) => {

        // Add a way to show a yellow icon for busy  offices and a red icon for very busy offices
         let IWTMarker = this.markerIconDLOopen

        if(this.getIWTLoadWindow !== undefined && this.getIWTLoadWindow === true && _loc.IWTwaitLevel === "yellow"){
          IWTMarker = this.markerIconDLOopenYellow
        } else if(this.getIWTLoadWindow !== undefined && this.getIWTLoadWindow === true && _loc.IWTwaitLevel === "red"){
          IWTMarker = this.markerIconDLOopenRed
        } else{
          IWTMarker = this.markerIconDLOopen
        }

        this.renderDMVLocs(
          _loc,
          "DLsaturday",
          this.layerOpenDLSaturdayOffice,
          IWTMarker
        );
      });

      // LPA offices, including those with kiosks. Default to "on" on page load
        // NO IWT as of 3/24
      this.getOfficeLPAwithKiosks.forEach((_loc) => {

        let LPAofficeMarker = this.markerIconLPAOpen

        // Add a way to show Kiosk locations with a different icon
        if(_loc.officeTypes.includes("kiosk") === true){
          LPAofficeMarker = this.markerIconLPAOkioskopen
        }

        this.renderDMVLocs(
          _loc,
          "plate",
          this.layerOpenLPAOfficeWithKiosks,
          LPAofficeMarker
        );
      });

      // Pins for LPA offices with no kiosks shown. Hidden on page load
      this.getOfficeLPA.forEach((_loc) => {
        this.renderDMVLocs(
          _loc,
          "plate",
          this.layerOpenLPAOffice,
          this.markerIconLPAOpen
        );
      });

      // Pins for all kiosk locations. Hidden on page load getOfficeKAllKiosks
      this.getOfficeKAllKiosks.forEach((_loc) => {
        let KioskOfficeMarker = this.markerIconDLOkioskopen

        // Add a way to show Kiosk locations with a different icon
        if(_loc.officeTypes.includes("plate") === true){
          KioskOfficeMarker = this.markerIconLPAOkioskopen
        }

        this.renderDMVLocs(
          _loc,
          "kiosk",
          this.layerOpenKioskDLOffices,
          KioskOfficeMarker
        );
      });

      // Pins for all kiosk LPA locations. Hidden on page load.
      this.getOfficeKAllKiosksLPA.forEach((_loc) => {
          
          let KioskOfficeMarker = this.markerIconDLOkioskopen

          // // Add a way to show Kiosk locations with a different icon
          // if(_loc.officeTypes.includes("plate") === true){
          //   KioskOfficeMarker = this.markerIconLPAOkioskopen
          // }

          this.renderDMVLocs(
            _loc,
            "kiosk",
            this.layerOpenKioskLPAOffices,
            KioskOfficeMarker
          );
      });


      // Pins for License and theft offices, hidden on page load
      this.getOfficeLT.forEach((_loc) => {
        this.renderDMVLocs(
          _loc,
          "lt",
          this.layerOpenLTOffice,
          this.markerIconLTOpen
        );
      });

      // Pins for IRP offices, hidden on page load
      this.getOfficeIRP.forEach((_loc) => {
        this.renderDMVLocs(
          _loc,
          "irp",
          this.layerOpenIRPOffice,
          this.markerIconIRPOpen
        );
      });

      // Pins for closed offices
      this.getClosedOfficeDL.forEach((_loc) =>{
        this.renderDMVLocs(
          _loc,
          "license",
          this.layerClosedDLOffice,
          this.markerIconDLClosed  
        );
      });

      this.getClosedOfficeLPA.forEach((_loc) => {
        this.renderDMVLocs(
          _loc,
          "plate",
          this.layerClosedLPAOffice,
          this.markerIconLPAClosed
        );
      });

      this.getClosedOfficeLT.forEach((_loc) => {
        this.renderDMVLocs(
          _loc,
          "lt",
          this.layerClosedLTOffice,
          this.markerIconLTClosed
        );
      });

      this.getClosedOfficeIRP.forEach((_loc) => {
        this.renderDMVLocs(
          _loc,
          "irp",
          this.layerClosedIRPOffice,
          this.markerIconIRPClosed
        );
      });

      this.getClosedOfficeKioskDLVR.forEach((_loc) => {
        this.renderDMVLocs(
          _loc,
          "kiosk",
          this.layerClosedKioskDLOffices,
          this.markerIconDLClosedKiosk
        );
      });
    },



    // Puts an individual pin on a map layer.  Expects a marker, and an office type, a layer, and an icon
    renderDMVLocs: function (marker, passedType, destinationLayer, markerIcon) {
      let markerMatchFound = false;
      // return console.log(markerIcon)

      // Utility: Parse HH:mm:ss to minutes
      function parseWaitTimeToMinutes(val) {
        if (typeof val === 'number') return val;
        if (typeof val === 'string' && val.includes(':')) {
          const parts = val.split(':');
          if (parts.length === 3) {
            const h = parseInt(parts[0], 10) || 0;
            const m = parseInt(parts[1], 10) || 0;
            const s = parseInt(parts[2], 10) || 0;
            return h * 60 + m + (s >= 30 ? 1 : 0); // round up if 30+ seconds
          }
        }
        const n = Number(val);
        return isNaN(n) ? null : n;
      }

      // Handle display of IWT times or messages
      const waitTimeDisplay = () =>{
        if (this.rootStore.allowedDateTime?.enableWaitTimesFeature) {
          // If its a state holiday, don't display wait time
          if (this.getIsStateHoliday === true) {
            return "<span></span>"
          }

          // If we're outside of IWT operating hours, show an office's custom message
          if (this.getIWTLoadWindow === false && marker.normalOfficeStatus !== "Closed" && marker.Custom !== null && marker.Custom !== undefined) {
            return "<li><strong>" + marker.Custom + "</strong></li>"
          }

          // If we're outside of IWT operating hours, show an office's custom message
          if (this.getIWTLoadWindow === false && marker.officeTypes === "license" && marker.normalOfficeStatus !== "Closed") {
            return "<li>Walk-in wait times are not displayed Monday-Friday before 9am.</li>"
          }

          // If we have a special custom per-office message from our officeMatch.data files, show that
          // Office must be open to display message.
          if (marker.normalOfficeStatus !== "Closed" && marker.Custom !== null && marker.Custom !== undefined) {
            return "<li><strong>" + marker.Custom + "</strong></li>"
          }

          // If we're a DL office with no IWT time, show a generic message
          if (marker.officeTypes === "license" && marker.normalOfficeStatus === "Open" && (marker.IWTavgWT == undefined || marker.IWTavgWT === null || marker.IWTavgWT === "")) {
            return "<li><em>Retrieving wait time....</em></li>"
          }
          if (marker.officeTypes === "license" && marker.normalOfficeStatus === "Open" && (marker.IWTavgWT == undefined || marker.IWTavgWT === null || marker.IWTavgWT === "") && (marker.IWTError === true || marker.IWTErrorMessage)) {
            return "<li><em>Wait times are not available right now</em></li>"
          }

          // If we're a VR office with no IWT time, show a generic message
          if (marker.officeTypes === "plate" && marker.normalOfficeStatus === "Open" && (marker.IWTavgWT == undefined || marker.IWTavgWT === null || marker.IWTavgWT === "")) {
            return "<span></span>"
          }
          if (marker.officeTypes !== "irp" && marker.officeTypes !== "irp,plate" && marker.IWTavgWT !== undefined && marker.IWTavgWT !== null && marker.IWTavgWT !== "" && marker.normalOfficeStatus === "Open") {
            const waitMins = parseWaitTimeToMinutes(marker.IWTavgWT);
            if(marker.IWTcapacity >= 97) {
              return "<li>At capacity — please try another office</li>"
            } else if (waitMins !== null && waitMins > 45) {
              return "<li><em>Busy — longer waits expected</em></li>" + "<li>Estimated Wait: " + waitTimeRange(marker.IWTavgWT) + "</li>";
            } else if (waitMins !== null) {
              return "<li><em>Accepting walk-ins & appointments </em></li>" + "<li>Estimated Wait: " + waitTimeRange(marker.IWTavgWT) + "</li>";
            } else {
              return "<li><em>Wait time unavailable</em></li>";
            }
          }

          // Show nothing
          else {
            return "<span></span>"
          }
        } // Show nothing
          else {
            return "<span></span>"
          }
      
     }

     // Handle holiday messaging
     const holidayMessageDisplay = () =>{
    
        // Kiosks don't observe holidays
        if(marker.officeTypes === "kiosk"){
          return marker.normalOfficeStatus
        }
        // Non-kiosks do observe holdiays
        else if(marker.officeTypes !== "kiosk" && this.getIsStateHoliday === true){
          return "Closed for the holiday" 
        }
        else if(marker.temporaryOfficeStatus === "Closed"){
          return "Closed"
        }
        else{
          return marker.normalOfficeStatus
        }

     }

      let toolTipTemplate =
        "<div class='leafletpopoutbox'><h6>" +  marker.name + "</h6>" +
        "<ul><li>Location is: <strong><em>" + holidayMessageDisplay() + "</em></strong></li>" +
         waitTimeDisplay() 
        + "<br/><em>Click for details</em>.</div>";

      destinationLayer.eachLayer((layer) => {
        if (marker.id === layer.options.id) {
          markerMatchFound = true;
          if (layer.options.icon !== markerIcon) {
            layer.setIcon(markerIcon);
          }
          if (layer.getTooltip().getContent() !== toolTipTemplate) {
            layer.bindTooltip(toolTipTemplate);
          }
           layer.on("mouseover", async () => {
            const latestOffice = this.getOfficeDL?.find(o => o?.id === marker?.id);
            if(latestOffice?.IWTOffice && this.getIsStateHoliday === false 
              && this.getIWTLoadWindow === true ){
            const IWTWaitTime = await fetchWaitTimeAndCapacity(latestOffice?.IWTOffice);
              if (marker.officeTypes === 'license') {
                marker.IWTavgWT = IWTWaitTime.waitTime;
                marker.IWTcapacity = IWTWaitTime.capacity;
                marker.IWTlastUpdated = IWTWaitTime.lastUpdated;
                marker.IWTError = IWTWaitTime.error;
                marker.IWTErrorMessage = IWTWaitTime.errorMessage;
              }
            }
             const updatedToolTipTemplate = "<div class='leafletpopoutbox'><h6>" + marker.name + "</h6>" +
               "<ul><li>Location is: <strong><em>" + holidayMessageDisplay() + "</em></strong></li>" +
               waitTimeDisplay()
               + "<br/><em>Click for details</em>.</div>";
             layer.bindTooltip(updatedToolTipTemplate);
          })
          layer.off("click");
          layer.on("click", () => {
            const latestOffice = this.getOfficeDL?.find(o => o?.id === marker?.id);
            if (latestOffice?.IWTOffice && this.getIsStateHoliday === false 
              && this.getIWTLoadWindow === true) {
              fetchWaitTimeAndCapacity(latestOffice?.IWTOffice).then(IWTWaitTime => {
              if (marker.officeTypes === 'license') {
                marker.IWTavgWT = IWTWaitTime.waitTime;
                marker.IWTcapacity = IWTWaitTime.capacity;
                marker.IWTlastUpdated = IWTWaitTime.lastUpdated;
                marker.IWTError = IWTWaitTime.error;
                marker.IWTErrorMessage = IWTWaitTime.errorMessage;
              }
              this.rootStore.SET_PRIMARY_CARD(marker);
            });
          }
            document
              .getElementById("selectedNearby")
              .scrollIntoView({ behavior: "smooth", block: "center" });
            this.rootStore.SET_PRIMARY_CARD(marker);
          });
          return;
        }
      })
      // return console.log(markerIcon)
      if (!markerMatchFound) {
        // Handle display of IWT times or messages
        // console.log(marker.IWTwaitLevel)
        L.marker(
          [marker.lat, marker.lon],

          { icon: markerIcon, id: marker.id }
        )
          //.addTo(destinationLayer)

          // Vue3's reactivity requires the use of toRaw here. Otherwise
          // leaflet.js 
          .addTo(toRaw(destinationLayer))

          .bindTooltip(toolTipTemplate, {
            offset: [0, 0],
          })

          .on("click", () => {
            const latestOffice = this.getOfficeDL?.find(o => o?.id === marker?.id);
            if (latestOffice?.IWTOffice && this.getIsStateHoliday === false
              && this.getIWTLoadWindow === true) {
              fetchWaitTimeAndCapacity(latestOffice?.IWTOffice).then(IWTWaitTime => {
                if (marker.officeTypes === 'license') {
                  marker.IWTavgWT = IWTWaitTime.waitTime;
                  marker.IWTcapacity = IWTWaitTime.capacity;
                  marker.IWTlastUpdated = IWTWaitTime.lastUpdated;
                  marker.IWTError = IWTWaitTime.error;
                  marker.IWTErrorMessage = IWTWaitTime.errorMessage;
                }
                this.rootStore.SET_PRIMARY_CARD(marker);
              })
            }

            document
              .getElementById("selectedNearby")
              .scrollIntoView({ behavior: "smooth", block: "center" });
            this.rootStore.SET_PRIMARY_CARD(marker);
          });
      }
    },

    // Creates the map and defines office layers
    createMap() {
      // Map
      var map = L.map("dmvLocsDashboard", {

        // zoomControl: false,zoom:1,zoomAnimation:false,fadeAnimation:false,markerZoomAnimation:false,

        // zoomAnimation:false,
        maxBounds: [
          // Can't pan and zoom to Nova Scotia or Austrailia.
          //south west
          [31.468108, -88.737305],
          //north east
          [39.195331, -71.487305],
        ],
        maxZoom: 16, // We can zoom to street level
        minZoom: 7, // We can't zoom out to outer space, though
      }).setView(this.setView, 7);

      this.dmvMap = map;

      // Layer for Map tiles
      L.tileLayer.bing(this.AVMoptions).addTo(this.dmvMap);

      // Add layers for markers
      this.layerClosedIRPOffice.addTo(this.dmvMap);
      this.layerClosedLTOffice.addTo(this.dmvMap);
      this.layerClosedDLOffice.addTo(this.dmvMap);
      this.layerClosedLPAOffice.addTo(this.dmvMap);
      this.layerClosedKioskDLOffices.addTo(this.dmvMap);
      // this.layerClosedMOOffice.addTo(this.dmvMap);

      this.layerOpenIRPOffice.addTo(this.dmvMap);
      this.layerOpenLTOffice.addTo(this.dmvMap);

      this.layerOpenLPAOfficeWithKiosks.addTo(this.dmvMap);
      this.layerOpenLPAOffice.addTo(this.dmvMap);
      this.layerOpenDLOffice.addTo(this.dmvMap);
      this.layerOpenDLOfficeWithKiosks.addTo(this.dmvMap)
      this.layerOpenDLSaturdayOffice.addTo(this.dmvMap);


      // Hide Saturday on start
      this.removeLayerFromMap('layerOpenDLSaturdayOffice');

      // Hide Kiosk layers on start:
      this.removeLayerFromMap('layerOpenKioskDLOffices')
      this.removeLayerFromMap('layerOpenKioskLPAOffices')

      // Hide DL and LPA without kiosks on start
      this.removeLayerFromMap('layerOpenDLOffice');
      this.removeLayerFromMap('layerOpenLPAOffice');

      // Hide L&T and IRP on start
      this.removeLayerFromMap('layerOpenIRPOffice');
      this.removeLayerFromMap('layerOpenLTOffice');


      // Hide Closed layers on start
      this.removeLayerFromMap('layerClosedIRPOffice');
      this.removeLayerFromMap('layerClosedLTOffice');
      this.removeLayerFromMap('layerClosedDLOffice');
      this.removeLayerFromMap('layerClosedLPAOffice');
      
    },


    // Updates map when toggles are toggled
    updateMapFromToggles(passedToggleStatus, toggelee, typeOfChange) {

      // Clear any cards shown on the screen, every time
      this.rootStore.SET_PRIMARY_CARD([]);
      this.rootStore.CLEAR_NEARBY_OFFICES([]);

      // console.log(passedToggleStatus)
      // console.log(toggelee)
      // console.log(typeOfChange)

      // console.log("The change was " + typeOfChange + " and was set to " + passedToggleStatus)
    
  
      // if(passedToggleStatus === true && typeOfChange === "toggleDL" ){
      //   console.log("DL TOGGLE CHANGE ON")
      // } else if(passedToggleStatus === false && typeOfChange === "toggleDL" ){
      //   console.log("DL TOGGLE CHANGE OFF")
      // }
      /* A: DL toggles */
      this.showClosedMarkers(this.getToggleClosed);
      // 1. DL activate. Saturday On. Kiosk On
      if(passedToggleStatus === true && typeOfChange === "toggleDL" && this.getToggleDLSaturday === true && this.getToggleDLkiosk === true){
        console.log("01. DL TOGGLE CHANGE ON. Kiosk On. Saturday On.")            
        return[
          this.removeLayerFromMap('layerOpenDLOffice'),
          this.removeLayerFromMap('layerOpenKioskDLOffices'),
          this.removeLayerFromMap('layerOpenDLOfficeWithKiosks'),
          this.dmvMap.addLayer(this.layerOpenKioskDLOffices),
          this.dmvMap.addLayer(this.layerOpenDLSaturdayOffice),
         ]        
      } 
      // 2. DL activate. Saturday On. Kiosk off
      else if(passedToggleStatus === true && typeOfChange === "toggleDL" && this.getToggleDLSaturday === true && this.getToggleDLkiosk === false){
        console.log("02. DL TOGGLE CHANGE ON. Kiosk off. Saturday On.")
        return[
          this.removeLayerFromMap('layerOpenKioskDLOffices'),
          this.removeLayerFromMap('layerOpenDLOffice'),
          this.removeLayerFromMap('layerOpenDLOfficeWithKiosks'),
          this.dmvMap.addLayer(this.layerOpenDLSaturdayOffice),
          ]   
      }
     
      // 3. DL activate. Saturday off. Kiosk On
      else if(passedToggleStatus === true && typeOfChange === "toggleDL" && this.getToggleDLSaturday === false && this.getToggleDLkiosk === true){
        console.log("03. DL TOGGLE CHANGE ON. Kiosk On. Saturday Off.")
        /* Might be able to OR this w/#1 */
        return[
          this.removeLayerFromMap('layerOpenDLOffice'),
          this.removeLayerFromMap('layerOpenKioskDLOffices'),
          this.dmvMap.addLayer(this.layerOpenDLOfficeWithKiosks)
         ]      
      } 

      // 4. DL activate. Saturday off. Kiosk off
      else if(passedToggleStatus === true && typeOfChange === "toggleDL" && this.getToggleDLSaturday === false && this.getToggleDLkiosk === false){
        console.log("04. DL TOGGLE CHANGE ON. Kiosk off. Saturday Off.")
        return[
          this.removeLayerFromMap('layerOpenKioskDLOffices'),
          this.removeLayerFromMap('layerOpenDLOfficeWithKiosks'),
          this.dmvMap.addLayer(this.layerOpenDLOffice)
          ]   
      }

      // 5. DL deactivate. Saturday On. Kiosk On
      else if(passedToggleStatus === false && typeOfChange === "toggleDL" && this.getToggleDLSaturday === true && this.getToggleDLkiosk === true){
        console.log("05. DL TOGGLE CHANGE OFF. Kiosk On. Saturday On.")
        return[
          this.removeLayerFromMap('layerOpenDLOfficeWithKiosks'),
          this.removeLayerFromMap('layerOpenDLOffice'),
          this.dmvMap.addLayer(this.layerOpenKioskDLOffices),
          this.dmvMap.addLayer(this.layerOpenDLSaturdayOffice)
         ] 
        
      } 
      // 6. DL deactivate. Saturday On. Kiosk off
      else if(passedToggleStatus === false && typeOfChange === "toggleDL" && this.getToggleDLSaturday === true && this.getToggleDLkiosk === false){
        console.log("06. DL TOGGLE CHANGE OFF. Kiosk off. Saturday On.")
        return[
          this.removeLayerFromMap('layerOpenDLOfficeWithKiosks'),
          this.removeLayerFromMap('layerOpenDLOffice'),
          this.removeLayerFromMap('layerOpenKioskDLOffices'),
          this.dmvMap.addLayer(this.layerOpenDLSaturdayOffice)
        ]   
      }
     
      // 7. DL deactivate. Saturday off. Kiosk On
      else if(passedToggleStatus === false && typeOfChange === "toggleDL" && this.getToggleDLSaturday === false && this.getToggleDLkiosk === true){
        console.log("07. DL TOGGLE CHANGE OFF. Kiosk On. Saturday Off.")
        return[
          this.removeLayerFromMap('layerOpenDLOfficeWithKiosks'),
          this.removeLayerFromMap('layerOpenDLOffice'),
          this.dmvMap.addLayer(this.layerOpenKioskDLOffices)
        ]   
      }

      // 8. DL deactivate. Saturday off. Kiosk off
      else if(passedToggleStatus === false && typeOfChange === "toggleDL" && this.getToggleDLSaturday === false && this.getToggleDLkiosk === false){
        console.log("08. DL TOGGLE CHANGE OFF. Kiosk off. Saturday Off.")
        return[
          this.removeLayerFromMap('layerOpenKioskDLOffices'),
          this.removeLayerFromMap('layerOpenDLOfficeWithKiosks'),
          this.removeLayerFromMap('layerOpenDLOffice')
        ]   
      }



      /* B: Saturday Toggles */

      // 9. Saturday Activate. Kiosk On. DL on.
      else if(passedToggleStatus === true && typeOfChange === "toggleSaturday" && this.getToggleDL === true && this.getToggleDLkiosk === true){
        console.log("09. SATURDAY TOGGLE ON. Kiosk on. DL On.")
        // return[
        //   this.dmvMap.removeLayer(this.layerOpenDLOffice),
        //   this.dmvMap.removeLayer(this.layerOpenKioskDLOffices),
        //   this.dmvMap.addLayer(this.layerOpenDLOfficeWithKiosks)
        //  ]    
          return [
          this.satrudayMode = true,
         
          // Hide LPA, L&T, and IRP, unlikely they're open on Saturday.
          this.rootStore.TOGGLE_SWITCH_LT(false),
          this.rootStore.TOGGLE_SWITCH_IRP(false),
          this.rootStore.TOGGLE_SWITCH_LPA(false),
          
          // Remove the DL layer (but don't mess with the toggles)
          this.removeLayerFromMap('layerOpenDLOfficeWithKiosks'),
          this.removeLayerFromMap('layerOpenDLOffice'),
          this.dmvMap.addLayer(this.layerOpenKioskDLOffices),
          this.dmvMap.addLayer(this.layerOpenDLSaturdayOffice), 

          // Show the Saturday DL Layer
          this.dmvMap.addLayer(toggelee)
        ]
      
      }
     
      // 10. Saturday Activate. Kiosk off. DL on.
      else if(passedToggleStatus === true && typeOfChange === "toggleSaturday" && this.getToggleDL === true && this.getToggleDLkiosk === false){
        console.log("10. SATURDAY TOGGLE ON. Kiosk off. DL On.")
        return[
          this.rootStore.TOGGLE_SWITCH_LT(false),
          this.rootStore.TOGGLE_SWITCH_IRP(false),
          this.rootStore.TOGGLE_SWITCH_LPA(false),
          this.removeLayerFromMap('layerOpenKioskDLOffices'),
          this.removeLayerFromMap('layerOpenDLOfficeWithKiosks'),
          this.removeLayerFromMap('layerOpenDLOffice'),
          this.dmvMap.addLayer(this.layerOpenDLSaturdayOffice)
          ]   
      }

      // 11. Saturday Activate. Kiosk on. DL off.
      else if(passedToggleStatus === true && typeOfChange === "toggleSaturday" && this.getToggleDL === false && this.getToggleDLkiosk === true){
        console.log("11. SATURDAY TOGGLE ON. Kiosk on. DL off.")
        return[
        this.rootStore.TOGGLE_SWITCH_DL(true),
          this.rootStore.TOGGLE_SWITCH_LT(false),
          this.rootStore.TOGGLE_SWITCH_IRP(false),
          this.rootStore.TOGGLE_SWITCH_LPA(false),
          this.removeLayerFromMap('layerOpenDLOfficeWithKiosks'),
          this.removeLayerFromMap('layerOpenDLOffice'),
          this.dmvMap.addLayer(this.layerOpenKioskDLOffices),
          this.dmvMap.addLayer(this.layerOpenDLSaturdayOffice)
        ]   
      }

      // 12. Saturday Activate. Kiosk off. DL off.
      else if(passedToggleStatus === true && typeOfChange === "toggleSaturday" && this.getToggleDL === false && this.getToggleDLkiosk === false){
        console.log("12. SATURDAY TOGGLE ON. Kiosk off. DL off.")
        return[
          this.rootStore.TOGGLE_SWITCH_DL(true),
          this.rootStore.TOGGLE_SWITCH_LT(false),
          this.rootStore.TOGGLE_SWITCH_IRP(false),
          this.rootStore.TOGGLE_SWITCH_LPA(false),
          this.removeLayerFromMap('layerOpenDLOfficeWithKiosks'),
          this.removeLayerFromMap('layerOpenDLOffice'),
          this.removeLayerFromMap('layerOpenKioskDLOffices'),
          this.dmvMap.addLayer(this.layerOpenDLSaturdayOffice)
        ]   
      }

      // 13. Saturday DeActivate. Kiosk On. DL on.
      else if(passedToggleStatus === false && typeOfChange === "toggleSaturday" && this.getToggleDL === true && this.getToggleDLkiosk === true){
        console.log("13. SATURDAY TOGGLE OFF. Kiosk on. DL On.")
        return[
          this.removeLayerFromMap('layerOpenDLOffice'),
          this.removeLayerFromMap('layerOpenKioskDLOffices'),
          this.removeLayerFromMap('layerOpenDLSaturdayOffice'),
          this.dmvMap.addLayer(this.layerOpenDLOfficeWithKiosks)
         ]  
      }
     
      // 14. Saturday DeActivate. Kiosk off. DL on.
      else if(passedToggleStatus === false && typeOfChange === "toggleSaturday" && this.getToggleDL === true && this.getToggleDLkiosk === false){
        console.log("14. SATURDAY TOGGLE OFF. Kiosk off. DL On.")
        return[
          this.removeLayerFromMap('layerOpenKioskDLOffices'),
          this.removeLayerFromMap('layerOpenDLOfficeWithKiosks'),
          this.removeLayerFromMap('layerOpenDLSaturdayOffice'),
          this.dmvMap.addLayer(this.layerOpenDLOffice)
         ]
      }

      // 15. Saturday DeActivate. Kiosk on. DL off.
      else if(passedToggleStatus === false && typeOfChange === "toggleSaturday" && this.getToggleDL === false && this.getToggleDLkiosk === true){
        console.log("15. SATURDAY TOGGLE OFF. Kiosk on. DL off.")
        return[
          this.removeLayerFromMap('layerOpenDLOfficeWithKiosks'),
          this.removeLayerFromMap('layerOpenDLOffice'),
          this.removeLayerFromMap('layerOpenDLSaturdayOffice'),
          this.dmvMap.addLayer(this.layerOpenKioskDLOffices)
         ]
      }

      // 16. Saturday DeActivate. Kiosk off. DL off.
      else if(passedToggleStatus === false && typeOfChange === "toggleSaturday" && this.getToggleDL === false && this.getToggleDLkiosk === false){
        console.log("16. SATURDAY TOGGLE OFF. Kiosk off. DL off.")
        return[
          this.removeLayerFromMap('layerOpenDLOfficeWithKiosks'),
          this.removeLayerFromMap('layerOpenDLOffice'),
          this.removeLayerFromMap('layerOpenKioskDLOffices'),
          this.removeLayerFromMap('layerOpenDLSaturdayOffice'),
         ]
      }




      /* C: Kiosk Toggles */

      // 17. Kiosk Activate. Saturday On. DL on.
      else if(passedToggleStatus === true && typeOfChange === "toggleKioskDL" && this.getToggleDL === true && this.getToggleDLSaturday === true){
        console.log("17. KIOSK TOGGLE ON. Saturday on. DL On.")
        return[
          this.removeLayerFromMap('layerOpenDLOffice'),
          this.removeLayerFromMap('layerOpenKioskDLOffices'),
          this.dmvMap.addLayer(this.layerOpenKioskDLOffices),
          this.dmvMap.addLayer(this.layerOpenDLSaturdayOffice),
         ]  
      }
     
      // 18. Kiosk Activate. Saturday off. DL on.
      else if(passedToggleStatus === true && typeOfChange === "toggleKioskDL" && this.getToggleDL === true && this.getToggleDLSaturday === false){
        console.log("18. KIOSK TOGGLE ON. Saturday off. DL On.")
        return[
          this.removeLayerFromMap('layerOpenDLOffice'),
          this.removeLayerFromMap('layerOpenKioskDLOffices'),
          this.dmvMap.addLayer(this.layerOpenDLOfficeWithKiosks)
         ]  
      }

      // 19. Kiosk Activate. Saturday on. DL off.
      else if(passedToggleStatus === true && typeOfChange === "toggleKioskDL" && this.getToggleDL === false && this.getToggleDLSaturday === true){
         console.log("19. KIOSK TOGGLE ON. Saturday on. DL off.")
        return[
          this.removeLayerFromMap('layerOpenDLOffice'),
          this.removeLayerFromMap('layerOpenKioskDLOffices'),
          this.dmvMap.addLayer(this.layerOpenKioskDLOffices),
          this.dmvMap.addLayer(this.layerOpenDLSaturdayOffice)
         ]  
      }

      // 20. Kiosk Activate. Saturday off. DL off.
      else if(passedToggleStatus === true && typeOfChange === "toggleKioskDL" && this.getToggleDL === false && this.getToggleDLSaturday === false){
         console.log("20. KIOSK TOGGLE ON. Saturday off. DL off.")
        return[
          this.removeLayerFromMap('layerOpenDLOffice'),
          this.removeLayerFromMap('layerOpenKioskDLOffices'),
          this.removeLayerFromMap('layerOpenDLSaturdayOffice'),
          this.dmvMap.addLayer(this.layerOpenKioskDLOffices),
         ]  


      }

      // 21. Kiosk DeActivate. Saturday On. DL on.
      else if(passedToggleStatus === false && typeOfChange === "toggleKioskDL" && this.getToggleDL === true && this.getToggleDLSaturday === true){
        console.log("21. KIOSK TOGGLE OFF. Saturday on. DL On.")
        return[
          this.removeLayerFromMap('layerOpenDLOfficeWithKiosks'),
          this.removeLayerFromMap('layerOpenKioskDLOffices'),
          this.removeLayerFromMap('layerOpenDLSaturdayOffice'),
          this.dmvMap.addLayer(this.layerOpenDLSaturdayOffice)
        ]
      }
     
      // 22. Kiosk DeActivate. Saturday off. DL on.
      else if(passedToggleStatus === false && typeOfChange === "toggleKioskDL" && this.getToggleDL === true && this.getToggleDLSaturday === false){
        console.log("22. KIOSK TOGGLE OFF. Saturday off. DL On.")
        return[
          this.removeLayerFromMap('layerOpenDLOfficeWithKiosks'),
          this.removeLayerFromMap('layerOpenKioskDLOffices'),
          this.removeLayerFromMap('layerOpenDLSaturdayOffice'),
          this.dmvMap.addLayer(this.layerOpenDLOffice),
        ]
      }

      // 23. Kiosk DeActivate. Saturday on. DL off.
      else if(passedToggleStatus === false && typeOfChange === "toggleKioskDL" && this.getToggleDL === false && this.getToggleDLSaturday === true){
        console.log("23. KIOSK TOGGLE OFF. Saturday on. DL off.")
        return[
          this.removeLayerFromMap('layerOpenDLOfficeWithKiosks'),
          this.removeLayerFromMap('layerOpenDLOffice'),
          this.removeLayerFromMap('layerOpenKioskDLOffices'),
          this.dmvMap.addLayer(this.layerOpenDLSaturdayOffice)
        ]
      }

      // 24. Kiosk DeActivate. Saturday off. DL off.
      else if(passedToggleStatus === false && typeOfChange === "toggleKioskDL" && this.getToggleDL === false && this.getToggleDLSaturday === false){
        console.log("24. KIOSK TOGGLE OFF. Saturday off. DL off.")
        return[
          this.removeLayerFromMap('layerOpenDLOfficeWithKiosks'),
          this.removeLayerFromMap('layerOpenDLOffice'),
          this.removeLayerFromMap('layerOpenKioskDLOffices')
        ]
      }



    //   /* VR toggles: */

      // Handle when user untoggles LPA and LPA kiosk is checked 
      else if(typeOfChange === "toggleLPA" && passedToggleStatus === false && this.getToggleLPAkiosk === true){
          // Clear cards
          this.rootStore.SET_PRIMARY_CARD([]);
          this.rootStore.CLEAR_NEARBY_OFFICES([]);
          return[
            // Untoggle LPA switch and kiosk
            this.rootStore.TOGGLE_SWITCH_LPA(false),
            this.rootStore.TOGGLE_SWITCH_KIOSK_VR(event.target.checked),
            // Hide layers
            this.removeLayerFromMap('layerOpenLPAOfficeWithKiosks'),
            this.removeLayerFromMap('layerOpenLPAOffice')
            ]   
      }

      // Handle when user retoggling LPA - we always reactivate kiosk checkbox
      else if(typeOfChange === "toggleLPA" && passedToggleStatus === true ){
          // Clear cards
          this.rootStore.SET_PRIMARY_CARD([]);
          this.rootStore.CLEAR_NEARBY_OFFICES([]);
          return[
            // Toggle LPA switch and kiosk checkbox
            this.rootStore.TOGGLE_SWITCH_LPA(true),
            this.rootStore.TOGGLE_SWITCH_KIOSK_VR(true),
            // Shows the layer that includes kisoks w/LPA offices
            this.dmvMap.addLayer(this.layerOpenLPAOfficeWithKiosks),
            ]   
      }

      // Handle when a user is deselecting VR when VR Kiosk checkbox is already off.
      else if(typeOfChange === "toggleLPA" && passedToggleStatus === false && this.getToggleLPAkiosk === false){
          this.rootStore.SET_PRIMARY_CARD([]);
          this.rootStore.CLEAR_NEARBY_OFFICES([]);
          return[
            this.removeLayerFromMap('layerOpenLPAOfficeWithKiosks'),
            this.removeLayerFromMap('layerOpenLPAOffice')
          ]
      }



      // Handle someone unchecks the LPA 'Include kiosks' checkbox... while LPA is active
        // The "show me only LPA offices with humans" use case
      else if (typeOfChange === "toggleKioskLPA" && passedToggleStatus === false && this.getToggleLPA === true){
        this.rootStore.SET_PRIMARY_CARD([]);
        this.rootStore.CLEAR_NEARBY_OFFICES([]);
        return[
          this.removeLayerFromMap('layerOpenLPAOfficeWithKiosks'), 
          this.dmvMap.addLayer(this.layerOpenLPAOffice)
          ]        
      }

      // Handle someone rechecks the LPA 'Include kiosks' checkbox... while LPA is active
         // The "show me both LPA offices with humans and kiosks"
      else if (typeOfChange === "toggleKioskLPA" && passedToggleStatus === true && this.getToggleLPA === true){
        this.rootStore.SET_PRIMARY_CARD([]);
        this.rootStore.CLEAR_NEARBY_OFFICES([]);
        return[
          this.dmvMap.addLayer(this.layerOpenLPAOfficeWithKiosks), 
          this.removeLayerFromMap('layerOpenLPAOffice')
          ]        
      }

      // Handle someone rechecking the LPA 'Include kiosks' checkbox... while LPA is inactive
        // The "show me just kiosks associated with LPA offices"
      else if (typeOfChange === "toggleKioskLPA" && passedToggleStatus === true && this.getToggleLPA === false){
        this.rootStore.SET_PRIMARY_CARD([]);
        this.rootStore.CLEAR_NEARBY_OFFICES([]);
        return[
          this.removeLayerFromMap('layerOpenLPAOfficeWithKiosks'), 
          this.removeLayerFromMap('layerOpenLPAOffice'),
          this.dmvMap.addLayer(this.layerOpenKioskLPAOffices) // Might need an open vr kiosk
          ]        
      }

      // Handle someone unchecking the LPA 'Include kiosks' checkbox... while LPA is also inactive. Very rare
        // The "show me no LPA offices of any kind"
      else if (typeOfChange === "toggleKioskLPA" && passedToggleStatus === false && this.getToggleLPA === false && this.getToggleLPAkiosk === false){
        // console.log("3")
        this.rootStore.SET_PRIMARY_CARD([]);
        this.rootStore.CLEAR_NEARBY_OFFICES([]);
        return[
          // this.dmvMap.removeLayer(this.layerOpenLPAfficeWithKiosks), 
          // this.dmvMap.removeLayer(this.layerOpenLPAOffice),
          this.removeLayerFromMap('layerOpenKioskLPAOffices')
          ]        
      }




      // Handles Commercial, L&T, and Closed offices.
      if (passedToggleStatus === true) {
        // add layer
        console.log('Toggled something besides DL or VR')
        // console.log(toggelee)
        return this.dmvMap.addLayer(toggelee);
      } else {
        // remove layer
        return this.dmvMap.removeLayer(toggelee);
      }


 
    },

    showClosedMarkers(passedToggleStatus) {
      console.log("Toggling open/closed switch")
      let closedOfficeslayersList = []
      if (passedToggleStatus === true) {
        // DL closed layer
        if (this.getToggleDL || this.getClosedOfficeMode) {
          this.dmvMap.addLayer(this.layerClosedDLOffice);
        } else {
          closedOfficeslayersList.push('layerClosedDLOffice');
        }
        // Closed kiosk layer: show if (DL closed toggle AND Include kiosks) OR closed-only mode
        if ((this.getToggleDLkiosk) || this.getToggleLPAkiosk || this.getClosedOfficeMode) {
          this.dmvMap.addLayer(this.layerClosedKioskDLOffices);
        } else {
          closedOfficeslayersList.push('layerClosedKioskDLOffices');
        }
        // LPA closed layer
        if (this.getToggleLPA || this.getClosedOfficeMode) {
          this.dmvMap.addLayer(this.layerClosedLPAOffice);
        } else {
          closedOfficeslayersList.push('layerClosedLPAOffice');
        }
        // LT closed layer
        if (this.getToggleLT || this.getClosedOfficeMode) {
          this.dmvMap.addLayer(this.layerClosedLTOffice);
        } else {
          closedOfficeslayersList.push('layerClosedLTOffice');
        }
        // IRP closed layer
        if (this.getToggleIRP || this.getClosedOfficeMode) {
          this.dmvMap.addLayer(this.layerClosedIRPOffice);
        } else {
          closedOfficeslayersList.push('layerClosedIRPOffice');
        }
      } else {
        closedOfficeslayersList.push('layerClosedIRPOffice', 'layerClosedLTOffice', 'layerClosedDLOffice', 'layerClosedLPAOffice', 'layerClosedKioskDLOffices');
      }
      closedOfficeslayersList.map(office => {
        this.removeLayerFromMap(office);
      })
    },
    mapZoomedExternal() {
      
        const zoomLat = parseFloat(this.getZoomedLocation.Lat)
        const zoomLong = parseFloat(this.getZoomedLocation.Long)

        console.log(zoomLat)
        console.log(zoomLong)

        if(this.getZoomedLocation !== undefined && this.getZoomedLocation !== null && zoomLat !== undefined && zoomLat !== null && zoomLong !== undefined && zoomLong !== null){
          // return this.dmvMap.flyTo([36.32434, -78.32423],12);
          return this.dmvMap.flyTo([zoomLat, zoomLong],12);
        }    
    },
    geoLocateZoomTo() {
      // Hide Primary card since it's no longer selected
      console.log("We are zooming to a location because lat/long has changed");
      this.rootStore.SET_PRIMARY_CARD([]);

      document
        .getElementById("dmvLocsDashboard")
        .scrollIntoView({ behavior: "smooth", block: "start" });

      // Draw marker at user's location
      if (this.getUserLocation !== undefined && this.getUserLocation !== null) {
        // When user's location indicated, zoom there!
        L.circle([this.getUserLocation?.Lat, this.getUserLocation?.Long], {
          color: "red",
          fillColor: "#f03",
          fillOpacity: 0.5,
          radius: 500,
        }).addTo(this.dmvMap);
        return this.dmvMap.flyTo([this.getUserLocation.Lat, this.getUserLocation.Long], 10);
      } else {
        return false
      }

},

  
  },
  mounted() {
    this.createMap();
  },
  watch: {
    getShowOnlyKiosk(){
      console.log("KIOSK MODE QUERY STRING " + this.getShowOnlyKiosk)

      // Toggle on any kiosk map layer
      this.dmvMap.addLayer(this.layerOpenKioskDLOffices)

      // // Hide DL and LPA without kiosks on start
      // this.dmvMap.removeLayer(this.layerOpenDLOffice);
      // this.dmvMap.removeLayer(this.layerOpenLPAOffice);

    },
    getOfficeDL: function(){
      // Watches for changes here, as you never know when IWT data will finish loading
      this.loadPins();
    },
    getUserLocation: function () {
      this.geoLocateZoomTo();
    },
    getZoomedLocation: function () {
      this.mapZoomedExternal();
    },
    // getDataLoaded: function () {
      // this.loadPins(); // Turned off and possibly not neede
    // },
    getToggleDL: function () {
      // this.updateMapFromToggles(this.getToggleDL, this.layerOpenDLOffice, "toggleDL");
      this.updateMapFromToggles(this.getToggleDL, this.layerOpenDLOfficeWithKiosks, "toggleDL");
    },
    getToggleLPA: function () {
      //this.updateMapFromToggles(this.getToggleLPA, this.layerOpenLPAOffice, "toggleLPA");
      this.updateMapFromToggles(this.getToggleLPA, this.layerOpenLPAOfficeWithKiosks, "toggleLPA");
    },
    getToggleLT: function () {
      this.updateMapFromToggles(this.getToggleLT, this.layerOpenLTOffice, "toggleLT");
    },
    getToggleIRP: function () {
      this.updateMapFromToggles(this.getToggleIRP, this.layerOpenIRPOffice, "toggleIRP");
    },

    getToggleDLSaturday: function(){
      this.updateMapFromToggles(this.getToggleDLSaturday, this.layerOpenDLSaturdayOffice, "toggleSaturday");
    },

    getToggleDLkiosk: function(){
      this.updateMapFromToggles(this.getToggleDLkiosk, this.layerOpenDLOffice, "toggleKioskDL");
    },

    // checkbox for LPA kiosks
    getToggleLPAkiosk: function(){
      this.updateMapFromToggles(this.getToggleLPAkiosk, this.layerOpenLPAOffice, "toggleKioskLPA");
    },


    getToggleClosed: function () {
      this.showClosedMarkers(this.getToggleClosed);
    },
    // Are we in the window of time to display Internet Wait Time?
    getIWTLoadWindow() {
      return this.rootStore.iwtLoadWindow;
    }
  },
};
</script>